import { isDragSource } from "shared/types/drag-and-drop/DragSource"

import z from "zod"

import { TableDragMetaSchema } from "../types/TableDragMeta"

export function isTableDragSource(source: unknown) {
  return isDragSource(source, {
    metaSchema: TableDragMetaSchema,
    dataSchema: z.object({ id: z.string() })
  })
}
